/*@ngInject*/
const changePasswordWithTokenRepository = function (baseRepository, cryptoUtil) {

    angular.extend(this, baseRepository);

    this.changePasswordWithToken = (username, loginToken, newPassword) => {
        const url = '/rest/User/changePassword',
            data = {
                username: username,
                loginToken: loginToken,
                newPassword: cryptoUtil.encryptWithServerPublicKey(newPassword)
            };

        return this.post(url, data);
    };
};

angular.module('gw-um-auth')
    .service('changePasswordWithTokenRepository', changePasswordWithTokenRepository);
